import React from "react";
import footerlogo from "../../utils/images/footer-logo.svg";
import heart from "../../utils/images/heart.svg";




function Footer() {
    return (
        <div className="footer">
            <div className="footer-area">
                <div className="container">
                    <div className="logo">
                        <a href="/">
                            <img src={footerlogo} alt="" />
                        </a>
                    </div>
                    <div className="copyright">
                        <a href="#">Terms & Conditions </a>
                        <a href="#">• Privacy Policy</a>
                    </div>
                    <div className="loyalty-text">
                       made with
                       <em>
                         <img src={heart} alt=""/>
                       </em>
                       by
                       <a href="https://softorigin.co.uk" target="_blank">Soft Origin</a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Footer;